// extracted by css-extract-rspack-plugin
export default {"cardWrapper":"cardWrapper-j5AjUD"};